import Controller from 'controllers/controller';
import Helpers from 'tools/helpers';
import EventManager from 'tools/event-manager';
import SharedEvents from 'tools/shared-events';
import Binder from 'tools/binder';
import raf from 'raf';
import $ from 'jquery';
import getPrefix from 'get-prefix';
import {TweenLite, Power2} from 'tools/gsap';

class HeaderController extends Controller {
    constructor(app) {
        super(app);
        
        this.events = new EventManager({
            bind: this
        });
        
        this.binder = new Binder(this);

        this.layers = [ ];
        this.layersByPage = { };
        this.elements = { };
        this.height = null;
        this.scrollTop = Helpers.getScrollTop();
        this.loopRunning = false;
        this.loopTimeout = null;
        this.hasCreatedLayersForPages = false;
        this.transformPrefixed = getPrefix('transform');
        
        // For IE scrolling
        this.maxScrollTop = 0;
        this.frames = 0;
        this.paints = 0;
        
        this.initSharedEvents();
        this.cacheElements();
        this.attachEvents();
        this.cacheDimensions();
        
        this.app.on('controllers-initialised', () => {
            this.attachPageChangeEvent();
            // this.setButtonSrc();
        });
        
        setTimeout(() => {
            if (this.layersEnabled()) {
                this.initLayers();
            }
        }, 10);

        setTimeout(() => {
            if (this.layersEnabled()) {
                this.initLayers();
            }
        }, 500);
    }
    
    layersEnabled() {
        return this.app.breakpointController.gte('md');
    }
    
    initLayers() {
        console.log('initLayers');

        if ( ! this.hasCreatedLayersForPages) {
            this.createLayersForPages();
        }
        
        this.cacheLayers();
        this.resizeLayers();
        this.updateLayers();
        this.paintLayers();
    }

    /**
     * Due to multiple layers of the same thing being required, the hover states of the components inside each layer
     * must be synchronised.
     */
    initSharedEvents() {
        let handler = (element, event) => {
            let method = event.type === 'mouseenter' ? 'add' : 'remove';
            
            element.classList[method]('hover');
        };
        
        this.sharedEvents = {
            languageSelector: new SharedEvents('#header .language-selector', {
                mouseenter: handler,
                mouseleave: handler
            }),
            menuButton: new SharedEvents('#header .menu-toggle', {
                mouseenter: handler,
                mouseleave: handler,
                click: null,
            })
        };
    }

    updateSharedEvents() {
        Object.keys(this.sharedEvents).forEach(key => {
            this.sharedEvents[key].update();
        })
    }

    attachEvents() {
        this.events.on(window, 'scroll', this.onWindowScroll);
        this.events.on(window, 'load', Helpers.repeatedFunction(5, 200, this.binder.bind('onWindowLoad')));
        this.events.on(window, 'resize', Helpers.delayedFunction(300, Helpers.repeatedFunction(5, 200, this.onWindowResize, this)));
        this.app.breakpointController.on('change', this.binder.bind('onBreakpointChange'));
        this.app.loaderController.on('page-loaded', Helpers.throttledFunction(250, this.binder.bind('onPageLoaded')));

        this.elements.bookATableButtons.forEach(button => {
            button.addEventListener('click', this.binder.bind('onBookATableClick'));
        });

        // setInterval(() => {
        //     console.log('frames: ' + this.frames);
        //     console.log('paints: ' + this.paints);
        // }, 8000);
    }

    attachPageChangeEvent() {
        this.app.pageController.on('change', this.binder.bind('onPageChange'));
    }
    
    getCurrentLang() {
        return document.documentElement.getAttribute('lang') || 'en';
    }

    getCurrentOppositeLangUrlForPage(page) {
        let currentLang = this.getCurrentLang(),
            pagePath = page.path,
            langPathMap = {
                en: '/',
                de: '/de/'
            },
            oppositeLangPathMap = {
                en: 'de/',
                de: ''
            },
            currentLangPath = langPathMap[currentLang],
            oppositeLangPath = oppositeLangPathMap[currentLang];

        if (pagePath.indexOf(currentLangPath) === 0) {
            pagePath = pagePath.substr(currentLangPath.length);
        }
        
        pagePath = APP_ROOT + oppositeLangPath + pagePath;
        
        return pagePath;
    }

    // setButtonSrc() {
    //     let src = this.app.bookATableController.getIframeSrc();
    //
    //     this.elements.bookATableButtons.forEach(button => {
    //         button.setAttribute('href', src);
    //     });
    // }

    onBookATableClick(event) {
        event.preventDefault();
        this.elements.srButton.click();
    }

    // onBookATableClick(event) {
    //     if (this.elements.bookATableModal && (this.app.iOSDevice || this.app.isSafari)) {
    //         return;
    //     }
    //
    //     event.preventDefault();
    //
    //     this.app.modalsController.openModal('book-a-table');
    // }

    onPageChange(page) {
        this.setLanguageSelectorHref(
            this.getCurrentOppositeLangUrlForPage(page)
        );
    }
    
    setLanguageSelectorHref(url) {
        this.sharedEvents.languageSelector.elements.forEach(selector => {
            selector.setAttribute('href', url);
        });
    }

    onPageLoaded() {
        this.onWindowResize();
    }

    onBreakpointChange() {
        // The layer system is only activated on medium and up devices.
        if (
            this.app.breakpointController.gte('md') &&
            // Prevent doubling up, since we're responsively doing this
            ! this.hasCreatedLayersForPages
        ) {
            this.initLayers();
        }
    }

    cacheElements() {
        this.elements.header = document.querySelector('#header');
        this.elements.$header = $(document.querySelector('#header'));
        this.elements.defaultLayer = this.elements.header.querySelector('.default-layer');
        this.elements.menuToggles = Array.from(this.elements.header.querySelectorAll('.menu-toggle'));
        this.elements.$menuToggles = this.elements.$header.find('.menu-toggle');
        this.elements.bookATableButtons = Array.from(this.elements.header.querySelectorAll('.book-a-table'));
        this.elements.bookATableModal = document.querySelector('#book-a-table.booking-engine--bookatable');
        this.elements.srButton = document.getElementById('sr-res-root');
    }

    cacheDimensions() {
        this.scrollTop = Helpers.getScrollTop();
        this.height = this.elements.header.offsetHeight;
        
        // Due to shitty syncing of scrolling to updating of scrollTop and animation frames in IE, we take over the
        // scroll in applyIEFixes(), but we need to test the values against the minimum and maximum scrollTop values.
        if (this.app.IEVersion) {
            this.maxScrollTop = document.body.scrollHeight - window.innerHeight;
        }
    }
    
    getPageByPath(path) {
        let match = null;
        
        this.app.pageController.pages.forEach(page => {
            if (page.path === path) {
                match = page;
            }
        });
        
        return match;
    }

    cacheLayers() {
        // Fetch all non-static layers
        this.elements.layers = Array.from(this.elements.header.querySelectorAll('.layer:not(.static)'));
        
        this.layers = this.elements.layers.map(layer => {
            let model = {
                element: layer,
                inner: layer.querySelector('.layer-inner'),
                color: layer.getAttribute('data-color'),
                page: this.getPageByPath(layer.getAttribute('data-page')),
                top: 0,
                height: 0
            };

            this.layersByPage[model.page] = model;

            return model;
        });
    }

    createLayersForPages() {
        let header = $('#header'),
            // Find all non static layers
            layers = header.find('.layer:not(.static)'),
            defaultLayer = layers.filter('.default-layer'),
            otherLayers = layers.filter('.layer:not(.default-layer)'),
            defaultLayerPage = defaultLayer.attr('data-page');

        // Remove other layers
        otherLayers.remove();

        this.app.pageController.pages.forEach(page => {
            // Skip layer for default page since this will exist on page load
            if (page.path === defaultLayerPage) {
                return;
            }

            let layer = $(defaultLayer[0].outerHTML);

            layer.removeClass('default-layer');
            layer.attr('data-color', page.headerColor);
            layer.attr('data-page', page.path);

            header.append(layer);
        });
        
        this.hasCreatedLayersForPages = true;
    }

    updateLayer(layer) {
        layer.top = layer.page.offsetTop - this.scrollTop;
    }

    updateLayers() {
        this.scrollTop = Helpers.getScrollTop();
        
        this.layers.forEach(layer => {
            this.updateLayer(layer);
        })
    }
    
    translateY(element, y) {
        element.style[this.transformPrefixed] = `translateY(${Math.round(y)}px)`;
    }

    /**
     * Layers are only resized when the window is resized, then on scroll only translations are applied to the layers
     * to show/hide certain parts.
     */
    resizeLayers() {
        this.layers.forEach(layer => {
            layer.height = layer.page.height;
            
            layer.element.style.height = layer.height + 'px';
        });
    }

    paintLayers() {
        this.paints += 1;
        
        this.layers.forEach(layer => {
            let wrapperTop = layer.top,
                innerTop = -layer.top;
            
            this.translateY(layer.element, wrapperTop);
            this.translateY(layer.inner, innerTop);
        })
    }

    update() {
        if (this.layersEnabled()) {
            this.updateLayers();
            this.paintLayers();
        }
    }

    frame() {
        this.frames += 1;
        
        this.update();

        if (this.loopRunning) {
            this.requestFrame();
        }
    }

    requestFrame() {
        raf(() => {
            this.frame();
        });
    }

    endLoop() {
        this.loopRunning = false;
        this.loopTimeout = null;
    }

    beginLoop() {
        if (this.loopRunning) {
            return;
        }

        this.requestFrame();

        this.loopRunning = true;
    }

    startLoopTimeout() {
        if (this.loopTimeout) {
            return;
        }

        this.loopTimeout = setTimeout(() => {
            this.endLoop();
        }, 500);
    }

    clearLoopTimeout() {
        if (this.loopTimeout) {
            clearTimeout(this.loopTimeout);

            this.loopTimeout = null;
        }
    }

    resetLoopTimeout() {
        this.clearLoopTimeout();
        this.startLoopTimeout();
    }

    onWindowScroll() {
        // Ignore on mobile
        if (this.app.breakpointController.lt('md')) {
            return;
        }
        
        // In IE, due to awfully glitchy scroll-based animations, updating the elements outside of a requestAnimationFrame
        // loop improves the situation.
        if (this.app.IEVersion) {
            this.update();
        } else {
            this.beginLoop();
            this.resetLoopTimeout();
        }
    }

    updateLayersEnabledClass() {
        if (this.layersEnabled()) {
            document.body.classList.add('layers-enabled');
        } else {
            document.body.classList.remove('layers-enabled');
        }
    }
    
    applyIEFixes() {
        let container,
            scrollTop;
        
        // IE 11 needs documentElement as container
        if (this.app.IEVersion <= 11) {
            container = document.documentElement;
            scrollTop = document.documentElement.scrollTop;
        }
        
        // Edge needs body, however
        else {
            container = document.body;
            scrollTop = document.body.scrollTop;
        }

        let onWheel = event => {
            event.preventDefault();

            //scrollTop = container.scrollTop;

            scrollTop += event.deltaY;

            if (scrollTop < 0) {
                scrollTop = 0;
            }

            if (scrollTop > this.maxScrollTop) {
                scrollTop = this.maxScrollTop;
            }

            TweenLite.killTweensOf(container);

            // So we can have some sort of smooth scrolling, still
            TweenLite.to(container, 0.2, {
                scrollTop,
                ease: Power2.easeOut
            });
        };

        let onScroll = () => {
            scrollTop = container.scrollTop;
        };

        container.addEventListener('wheel', onWheel, { passive: false, capture: true });
        // 300ms after last scroll, update the current scrollTop value
        window.addEventListener('scroll', Helpers.delayedFunction(300, onScroll), { passive: false });
    }

    onWindowLoad() {
        this.updateLayersEnabledClass();
        
        if (this.layersEnabled()) {
            this.cacheDimensions();
            this.initLayers();
        }
        
        // IE and it's usual glitchy shenanigans strikes again, and due to the fact that nobody who uses the browser
        // really cares about the website they're using, let's just hack it rather than waste time on blind eyes.
        if (this.app.IEVersion) {
            this.applyIEFixes();
            
            this.IEFixInterval = setInterval(() => this.onWindowResize(), 1000);
            setTimeout(() => clearInterval(this.IEFixInterval), 5000);
        }

        setTimeout(() => {
            this.onWindowResize();
        }, 1000);
    }

    onWindowResize() {
        this.updateLayersEnabledClass();
        
        if (this.layersEnabled()) {
            this.cacheDimensions();
            this.initLayers();
        }
    }
}

export default HeaderController;